export * from "-!../../vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../vue-loader/lib/index.js??vue-loader-options!./BounceLoader.vue?vue&type=template&id=25786eca&"


//////////////////
// WEBPACK FOOTER
// /Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/vue-spinner/src/BounceLoader.vue?vue&type=template&id=25786eca&
// module id = 621
// module chunks = 0